import React, { MouseEvent, MutableRefObject } from "react";
import type { Children } from '../../custom-types'

declare const window: any;

interface SmoothScrollLinkI {
  children?: Children;
  id: keyof HTMLElementTagNameMap | string;
  link_id?: string | null | undefined;
  offset: MutableRefObject<number> | number;
  offsetMobile: number;
  className?: string;
}

const SmoothScrollLink: React.FC<SmoothScrollLinkI> = ({ children, ...props }) => {
  const smoothScrollTo = (event: MouseEvent) => {
    event.preventDefault();
    const destination = document.querySelector(props.id);
    if (destination == null) return;
    let offset = props.offset;
    if (typeof props.offset !== 'number') {
      offset = props.offset.current;
    }

    const elementPosition = destination.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - (offset as number);
    const offsetPositionMobile = elementPosition + window.pageYOffset - props.offsetMobile;

    // Get the parent's sibling element
    const parent = destination.parentElement;
    const siblingElement = parent?.nextElementSibling;

    // Add marginBottom to the sibling element
    // this handles the edge case when the element is at the bottom
    // of the container and the elment doesn't scroll into view
    if (siblingElement instanceof HTMLElement) {
      const rect = parent?.getBoundingClientRect();

      // Check if the target element is within the viewport or near the bottom edge
      if (rect !== undefined && rect.bottom <= window.innerHeight) {
        siblingElement.style.marginBottom = "500px";
      }
    }

    // want to enable the backbutton for on page links
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.requestAnimationFrame(() =>
        window.scrollTo({
          top: offsetPositionMobile,
          behavior: 'smooth',
        })
      );
      window.history.pushState(window.state, null, props.id);
    } else {
      window.requestAnimationFrame(() =>
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
      );
      window.history.pushState(window.state, null, props.id);
    }

    // Remove marginBottom from the sibling element after scroll
    const handleScroll = () => {
      if (siblingElement instanceof HTMLElement) {
        siblingElement.style.marginBottom = '';
      }
      window.removeEventListener('scroll', handleScroll);
    };

    // Listen for the scroll event to remove marginBottom
    window.addEventListener('scroll', handleScroll);

    if (typeof props.offset !== 'number' && props.offset.current !== undefined) {
      props.offset.current = 0;
    }
  };

  return (
    <a href={props.id} className={props.className || ''} id={props.link_id || ''} onClick={smoothScrollTo}>
      <>
        {children}
      </>
    </a>
  );
}

export default SmoothScrollLink;
